export default "__VITE_ASSET__49f9e79e__"